module.exports = __webpack_public_path__ + "static/img/yzewm.63a7733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yzewm.jpg
// module id = BuVL
// module chunks = 1